import { render, staticRenderFns } from "./ProjectViewSettings.vue?vue&type=template&id=1ccfceb0&"
import script from "./ProjectViewSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectViewSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewSettings.vue?vue&type=style&index=0&id=1ccfceb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow,VSpacer})
